import { Card } from "@/components/reusables/ui/card"
import { Horizontal } from "@/components/standard/BFLayout"
import { H5 } from "@/components/standard/BFText"
import ArrowRight from "phosphor-react-native/src/icons/CaretRight"
import { Pressable } from "react-native"

export const ActionCard = ({
  title,
  testID,
  onPress,
}: {
  testID: string
  title: string
  onPress: () => void
}) => {
  return (
    <Pressable testID={testID} onPress={onPress}>
      <Card className={"mt-2"}>
        <Horizontal className="items-center justify-between p-3">
          <H5>{title}</H5>
          <ArrowRight size={20} />
        </Horizontal>
      </Card>
    </Pressable>
  )
}
